import React, { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { FileText, Eye, EyeOff } from 'lucide-react';
import employeeApi from '../../lib/employeeApi';
import EmployeeLayout from '../../components/EmployeeLayout';
import { getEmployeeUser } from '../../lib/employeeAuth';

export default function DocumentsPage() {
  const employee = getEmployeeUser();
  const [docs, setDocs] = useState(null);
  const [showSensitive, setShowSensitive] = useState(false);

  useEffect(() => {
    const fetchDocs = async () => {
      try {
        const res = await employeeApi.get('/api/employee/documents');
        setDocs(res.data);
      } catch (error) {
        toast.error('Failed to load');
      }
    };
    fetchDocs();
  }, []);

  if (!docs) return <EmployeeLayout><div className="p-8">Loading...</div></EmployeeLayout>;

  return (
    <EmployeeLayout>
      <div className="p-8">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold text-charcoal-900">My Documents</h1>
          <button onClick={() => setShowSensitive(!showSensitive)} className="px-4 py-2 bg-charcoal-100 text-charcoal-700 rounded-xl hover:bg-charcoal-200 flex items-center gap-2">
            {showSensitive ? <><EyeOff className="w-4 h-4" />Hide Sensitive</> : <><Eye className="w-4 h-4" />Show Sensitive</>}
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-white rounded-xl border border-charcoal-200 p-6">
            <h3 className="font-semibold text-charcoal-900 mb-4 flex items-center gap-2">
              <FileText className="w-5 h-5 text-pink-600" />
              Aadhar Card
            </h3>
            {showSensitive ? (
              docs.aadhar_file_id ? (
                <a href={`/api/files/${docs.aadhar_file_id}`} target="_blank" rel="noopener noreferrer" className="text-pink-600 hover:text-pink-700">View Document</a>
              ) : (
                <p className="text-sm text-neutral-600">Not uploaded</p>
              )
            ) : (
              <p className="text-sm text-neutral-600">Hidden - Click &quot;Show Sensitive&quot; to view</p>
            )}
          </div>

          <div className="bg-white rounded-xl border border-charcoal-200 p-6">
            <h3 className="font-semibold text-charcoal-900 mb-4 flex items-center gap-2">
              <FileText className="w-5 h-5 text-pink-600" />
              PAN Card
            </h3>
            {showSensitive ? (
              docs.pan_file_id ? (
                <a href={`/api/files/${docs.pan_file_id}`} target="_blank" rel="noopener noreferrer" className="text-pink-600 hover:text-pink-700">View Document</a>
              ) : (
                <p className="text-sm text-neutral-600">Not uploaded</p>
              )
            ) : (
              <p className="text-sm text-neutral-600">Hidden - Click &quot;Show Sensitive&quot; to view</p>
            )}
          </div>
        </div>
      </div>
    </EmployeeLayout>
  );
}